module.exports = __webpack_public_path__ + "static/media/GisIcon.d31fdbf6.svg";